import React from 'react';

const Input = ({ 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  name, 
  className = '', 
  icon: Icon,
  label,
  error,
  required = false,
  disabled = false,
  ...props 
}) => {
  const baseStyles = "w-full px-3 py-2 border rounded-lg shadow-sm transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-juridica-realce focus:border-transparent";
  const errorStyles = error ? "border-red-500 focus:ring-red-500" : "border-juridica-borda";
  const disabledStyles = disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white";
  
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <div className="relative">
        {Icon && (
          <Icon 
            size={18} 
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" 
          />
        )}
        
        <input 
          type={type} 
          name={name} 
          placeholder={placeholder} 
          value={value} 
          onChange={onChange} 
          required={required}
          disabled={disabled}
          className={`
            ${baseStyles} 
            ${errorStyles} 
            ${disabledStyles}
            ${Icon ? 'pl-10' : ''} 
            ${className}
          `}
          {...props}
        />
      </div>
      
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export { Input };
export default Input;
